import { useEffect, useRef, useState } from "react";
import Icon from "./panel/Icon";

// Avisos flotantes de MiQRapp (reemplazan a react-toastify). Cualquier archivo llama
// a toast.success/toast.error, y los muestra el <Toaster> que tenga la página.
let listener = null;
let nextId = 1;

const push = (type, message) => listener && listener({ id: nextId++, type, message });

export const toast = {
    success: (message) => push("success", message),
    error: (message) => push("error", message)
};

const DURATION = 4500;

const ToastItem = ({ item, onClose }) => {

    const [leaving, setLeaving] = useState(false);
    const timer = useRef();

    const close = () => {
        setLeaving(true);
        setTimeout(onClose, 200);
    }

    const start = () => {
        clearTimeout(timer.current);
        timer.current = setTimeout(close, item.type === "error" ? DURATION + 1500 : DURATION);
    }

    useEffect(() => {
        start();
        return () => clearTimeout(timer.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <div className={"lp-toast lp-toast-" + item.type + (leaving ? " lp-toast-out" : "")} role={item.type === "error" ? "alert" : "status"}
        onMouseEnter={() => clearTimeout(timer.current)} onMouseLeave={start}>
        <span className="lp-toast-icon" aria-hidden="true">
            <Icon name={item.type === "error" ? "alert" : "check"} size={16} strokeWidth={2.8}></Icon>
        </span>
        <p>{item.message}</p>
        <button type="button" className="lp-toast-close" onClick={close} aria-label="Cerrar aviso"><Icon name="close" size={16}></Icon></button>
    </div>
  )
}

// Va dentro del contenedor .lp de la página para tomar sus colores (claro u oscuro).
export const Toaster = () => {

    const [items, setItems] = useState([]);

    useEffect(() => {
        listener = (item) => setItems((list) => [...list.slice(-2), item]);
        return () => { listener = null; };
    }, []);

  return (
    <div className="lp-toaster" aria-live="polite">
        {items.map((item) => (
            <ToastItem key={item.id} item={item} onClose={() => setItems((list) => list.filter((i) => i.id !== item.id))}></ToastItem>
        ))}
    </div>
  )
}
